import React from "react";
import './loader.css'
// style="--b: 5px;--c: green;width: 80px;--n: 6;--g: 20deg"
// style="--b: 15px;--c: blue;width: 120px;--n: 8"
const Loader = () => {
  return (
    <div style={{width: '100%', height: '80vh', display: 'grid', placeItems: 'center'}}>
      <div className="loader"></div>
      {/* <div className="loader"></div>
      <div
        className="loader"
        
      ></div>
      <div
        className="loader"
        style={{border: '20px', color: 'var(--color-primary)', width: '80px',gap: '7deg'}}
      ></div> */}
    </div>
  );
};

export default Loader;
